import { styled, Typography } from '@mui/material';

const Wrapper = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(7.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
}));
const Header = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.spacing(2.5),
    lineHeight: theme.spacing(3.5),
}));
const Description = styled(Typography)(({ theme }) => ({
    margin: theme.spacing(1, 2.5, 0, 2.5),
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    textAlign: "center",
}));
const Actions = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export { Actions, Description, Header, Wrapper };
//# sourceMappingURL=SelectCustomerNoResults.js.map
